// Imports
import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from 'react-router-dom';

// Views
// import SettingsMainView from "Modules/settings/views/main"
import { HasPermission } from "Core/security";

// Router
const SettingsView = (props) => {
  const { match } = props;
  const user = useSelector((state) => state.securityRedux.user);

  return (
    <Routes>
      {/* {HasPermission(user, ['alrt', 'sr', 'xml', 'kml', 'lmup'], [23]) && ( */}
      {
        HasPermission(user, ['manage'], [23]) && (
          <Fragment>
            <Route path='/' element={<Navigate to="/app/settings/main" />}></Route>
            {/* <Route path='main' element={<SettingsMainView />} /> */}
          </Fragment>
        )
      }
      <Route path="*" element={<Navigate to="/app/error" />} />
    </Routes>
  );
};

export default SettingsView;
